import { Tooltip } from 'devextreme-react';
import './RenderImportedOrder.scss';
import { formatMessage } from 'devextreme/localization';

export const RenderImportedOrder = () => {
  return (
    <div className='status status-contact color-view'>
      <Tooltip target={'#OrdImported'} showEvent='mouseenter' hideEvent='mouseleave' hideOnOutsideClick={false}>
        <div>{formatMessage('OrdImported')}</div>
      </Tooltip>
      <span id='OrdImported'>
        {' '}
        | <i className={`dx-icon dx-icon-importselected customiconImp`}></i>
      </span>
    </div>
  );
};
